// @flow
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { mediaQuery } from '@tablekit/utils';
import type { MediaQueryType } from '@tablekit/utils/types';
import LazyLoad from 'react-lazyload';
import { LAZY_LOAD_OFFSET } from 'utils/theme';
import CoreImage from './Image';
import useMediaQuery from '../utils/useMediaQuery';

export const SIZES = {
  BLOG: '73px',
  BLOG_MOBILE: '52px',
  BLOG_FOOTER: '132px',
  QUOTE: '84px',
  TESTIMONIAL: '72px',
  TESTIMONIAL_MOBILE: '90px',
  LARGE: '120px',
  DEFAULT: '60px'
};

// eslint-disable-next-line flowtype/require-types-at-top
type PropsType = {
  alt: string,
  size?: MediaQueryType<$Values<typeof SIZES>>,
  src: string
};

const ImageWrapper = styled('div', {
  shouldForwardProp: (prop) => ['size'].indexOf(prop) === -1
})`
  border-radius: 50%;
  overflow: hidden;
  ${mediaQuery(
    'size',
    (size = SIZES.DEFAULT) => css`
      width: ${size};
      min-width: ${size};
      height: ${size};
      min-height: ${size};
    `
  )}
`;
const Image = styled(CoreImage)`
  &,
  & > * {
    // This forces the image to fill at all times (due to picture styles)
    width: 100%;
    height: 100%;
  }
`;

const DEFAULT_SIZE = parseFloat(SIZES.DEFAULT);

const PersonImage = ({ alt, src, size, ...props }: PropsType) => {
  let responsiveSize = size;
  if (typeof size === 'object') responsiveSize = useMediaQuery(size);
  const options = {
    size: {
      // For clarity use 2x desired size
      width: 2 * (parseFloat(responsiveSize) || DEFAULT_SIZE),
      height: 2 * (parseFloat(responsiveSize) || DEFAULT_SIZE)
    }
  };
  return (
    <ImageWrapper size={size} {...props}>
      <LazyLoad offset={LAZY_LOAD_OFFSET}>
        <Image src={src} alt={alt} options={options} />
      </LazyLoad>
    </ImageWrapper>
  );
};

export default PersonImage;
